import React from 'react';
import { STATUS } from './api';

export default function Etiqueta({ status }) {
  const s = STATUS[status] || STATUS.enviada;
  return (
    <span
      style={{
        display: 'inline-block', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999,
        letterSpacing: '.04em', color: s.cor, background: s.fundo, whiteSpace: 'nowrap',
      }}
    >
      {s.rotulo}
    </span>
  );
}
